import { createContext, useContext, useState } from "react";

const StepperContext = createContext({
  currentStep: null,
  navigate: () => {},
});

const Stepper = ({ children, initialStep }) => {
  const [currentStep, setCurrentStep] = useState(initialStep);

  const navigate = (step) => {
    setCurrentStep(step);
  };

  return (
    <StepperContext.Provider value={{ currentStep, navigate }}>
      {typeof children === "function" ? (
        <StepperContext.Consumer>
          {(context) => children(context)}
        </StepperContext.Consumer>
      ) : (
        children
      )}
    </StepperContext.Provider>
  );
};

const Step = ({ children, id }) => {
  const { currentStep } = useStepper();

  if (currentStep !== id) {
    return null;
  }

  return children;
};

const useStepper = () => {
  const context = useContext(StepperContext);

  if (!context) {
    throw new Error("useStepper must be used within a StepperProvider");
  }

  return context;
};

export { Stepper, Step, useStepper };
